/**
 * Виды событий бота по-человечески.
 *
 * На проводе `kind` — свободная строка, которую рантайм заводит сам (docs/06 §9),
 * и в ленте она показывалась как есть: `antiAfk`, `viewer`, `compat`. Оператору
 * это ничего не говорит, а именно по ленте он решает, идти чинить или нет.
 * Поэтому здесь словарь известных видов, а неизвестный вид отдаётся кодом —
 * лучше сырой ярлык, чем «прочее», которое скрывает, что именно случилось.
 *
 * Словарь собран по фактическим вызовам `ctx.log`/`this.event` в рантайме
 * (`apps/runner/src/worker/**`) и по видам, которые заводит API.
 */

const KIND_LABEL: Record<string, string> = {
  state: 'состояние',
  chat: 'чат',
  command: 'команда',
  kick: 'отключение',
  auth: 'авторизация',
  error: 'ошибка',
  compat: 'совместимость',
  death: 'смерть',
  viewer: 'камера',
  hook: 'хук сервера',
  alert: 'оповещение',
  behaviour: 'поведение',
  antiAfk: 'антикик',
  autoEat: 'автоеда',
  anchor: 'якорь чанков',
  unknown: 'без вида'
}

/** `antiAfk` → `антикик`. Незнакомый вид возвращается как есть. */
export function eventKindLabel(kind: string): string {
  return KIND_LABEL[kind] ?? kind
}

/**
 * Показывать ли рядом с названием сырой код.
 *
 * Код нужен: по нему фильтруют логи и его пишут в issue. Но если перевода нет,
 * название И ЕСТЬ код — дублировать его вторым чипом незачем.
 */
export function hasKindLabel(kind: string): boolean {
  return KIND_LABEL[kind] !== undefined
}
